import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ResolvableModal } from '@softline/ui-core';
import { MdcInventory } from '../../types/mdc-inventory';
import { StorageLocationSearchComponent } from '../../components/storage-location-search/storage-location-search.component';
import { StorageLocationSearchRepository } from '../../components/storage-location-search/repositories/storage-location-search.repository';

@Component({
  selector: 'soft-storage-location-modal',
  imports: [StorageLocationSearchComponent],
  templateUrl: './storage-location-modal.component.html',
  styleUrl: './storage-location-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [StorageLocationSearchRepository],
})
export class StorageLocationModalComponent extends ResolvableModal<any> {
  readonly storageLocation = input<any | null>();
  readonly inventory = input.required<MdcInventory & any>();

  protected readonly idlagerstamm = computed(
    () => this.inventory()?.stock?.['id'] ?? undefined
  );
}
